import React from "react";
import { ProducerReportTemplate } from "themes/common/components/producer";

function ProducerReport(props) {
    return <ProducerReportTemplate {...props} />;
}

export default ProducerReport;
